var ContentServerClient = require('./contentServerClient');
var OfflineClient = require('./offlineClient');

///////////////
//constructor//
///////////////
var DataManagerClientFactory = function () {};
module.exports = DataManagerClientFactory;

//////////
//static//
//////////
DataManagerClientFactory.getInstance = function(config, userController) {
    return DataManagerClientFactory._init(config, userController);
};

///////////
//private//
///////////
DataManagerClientFactory._init = function (config, userController) {
    if (config.type === 'ContentServer') {
        return new ContentServerClient(config, userController);
    } if (config.type === 'Offline') {
        return new OfflineClient(config);
    } else {
        throw new Error('Configuration error: Incorrect type of ColabDocStoreConfig. For now, only \'ContentServer\' or \'Offline\' are supported.');
    }
};
